export default "__VITE_ASSET__DNhy7s3T__"